import { render, staticRenderFns } from "./ed-class-schedule-sidebar.component.vue?vue&type=template&id=7fc69d07&scoped=true&"
import script from "./ed-class-schedule-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-sidebar.component.scss?vue&type=style&index=0&id=7fc69d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc69d07",
  null
  
)

export default component.exports